const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+BI+Points+API


function getBiPoints(userProfileId, source = 'profile') {
    const biProfile = require('utils/BiProfile');
    let url = `/api/bi/profiles/${userProfileId}/points?source=${source}`;
    if (source === biProfile.SOURCES.ORDER_CONFIRMATION) {
        url += '&isLastOrder=true';
    }
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = getBiPoints;
